module.exports = __webpack_public_path__ + "static/img/project4.d376984.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project4.jpg
// module id = 745
// module chunks = 1